import Host from '@interfaces/device/host';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

type SubheaderDevicesProps = {
  onToggle: () => void,
  addNew: () => void
  hostToDevice?: Host
}

const SubHeaderDevices = ({onToggle, addNew, hostToDevice}: SubheaderDevicesProps) => {
  const { t } = useTranslation(['myDevices']);
  const history = useNavigate();

  const addNewDevice = () => {
    onToggle();
    addNew();
  }

  return (
    <div className="Services__FlexContentInside">
       <div className="title-btn">
          <div className="HorizontalFlex__Gap items__center">
              <i className="far fa-arrow-left" onClick={() => history(-1)}/>
              <i className='fas fa-folder-open'/>
              <h2 className="Title5">{hostToDevice?.identificationHost}</h2>
              {/* <h2 className="Title5">{hostToDevice?.identificationHost}: {hostToDevice?.host}</h2> */}
          </div>
        
      </div>
      <div className="Profile__FlexItem-NoPadding" onClick={addNewDevice}>
        <button className="btn-primary" >
          <i className="far fa-plus"/>
          <p className="Body2">
            {t('add')}
          </p>
        </button>
      </div>
    </div>
  );
};

export default SubHeaderDevices;
